module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson5/pages/lesson_5_12.pdf";